import { render, staticRenderFns } from "./WalkSettingWindow.vue?vue&type=template&id=3b68698e&scoped=true&lang=pug"
import script from "./WalkSettingWindow.vue?vue&type=script&lang=ts"
export * from "./WalkSettingWindow.vue?vue&type=script&lang=ts"
import style0 from "./WalkSettingWindow.vue?vue&type=style&index=0&id=3b68698e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68698e",
  null
  
)

/* custom blocks */
import block0 from "./WalkSettingWindow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports